import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Dialog from 'material-ui/Dialog';
import styled from 'styled-components';
import Colors from '../../../../styles/colors';

import Profile from './profile';
import Transactions from './transactions';
import Account from './account';
import Promotions from './promotions';
import Integrations from './integrations';
import WhiteLabel from './whiteLabel';
import { ActionButton } from '../../../../components/buttons/buttons';
import { STATIC_HOMEPAGE_URL } from '../../../../config';
import { canUserAccessFeature } from '../../../../helpers/userinfoHelper';

const publisherTabs = [
  ['/dashboard/publisher', 'Profile'],
  ['/dashboard/publisher/transactions', 'Transactions'],
  ['/dashboard/publisher/promotions', 'Promotions'],
  ['/dashboard/publisher/integrations', 'Integration'],
  ['/dashboard/publisher/whiteLabel', 'White Label'],
  ['/dashboard/publisher/account', 'Account'],
];

class Publisher extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: {
        show: false,
        title: '',
        content: '',
        actionLabel: 'Upgrade',
        onClose: () => {},
        upgrade: false,
        cancel: true,
      },
    };

    this.showAlertModal = this.showAlertModal.bind(this);
  }

  alertModalHandler(metadata = {}) {
    let {
      show = false,
      title = '',
      content = '',
      upgrade = false,
      onClose = false,
      cancel = true,
    } = metadata;

    return () => {
      let { onClose: oldClose } = this.state.modal;
      this.setState(
        {
          modal: {
            ...this.state.modal,
            show,
            title,
            content,
            upgrade,
            onClose: !show ? false : onClose,
            cancel,
          },
        },
        () => {
          if (oldClose && !show) {
            oldClose();
          }
        }
      );
    };
  }

  showAlertModal(metadata = {}) {
    this.alertModalHandler({
      show: true,
      ...metadata,
    })();
  }

  renderAlertModal() {
    const { show, title, content, upgrade, cancel } = this.state.modal;
    const actionLabel = upgrade ? 'Upgrade' : 'OK';
    const actionBtnClick = upgrade
      ? () => this.props.history.push('/pricing')
      : this.alertModalHandler({ show: false });
    const actions = [
      <div style={{ textAlign: 'center', padding: 20 }}>
        <ActionButton onClick={actionBtnClick}>{actionLabel}</ActionButton>
        {cancel && (
          <ActionButton
            textColor="#f76b1c"
            backgroundColor="#fff"
            onClick={this.alertModalHandler({ show: false })}>
            Cancel
          </ActionButton>
        )}
      </div>,
    ];

    return (
      <Dialog
        title={
          <div className="title-medium" style={{ fontWeight: 800, textAlign: 'center' }}>
            {title}
            <div
              style={{ cursor: 'pointer', float: 'right', fontSize: 29 }}
              onClick={this.alertModalHandler({ show: false })}>
              &#10799; {/* Close button (X) */}
            </div>
          </div>
        }
        actions={actions}
        modal={false}
        open={show}
        onRequestClose={this.alertModalHandler({ show: false })}>
        <div className="title-small" style={{ textAlign: 'center', padding: '0 20px' }}>
          {content}
        </div>
      </Dialog>
    );
  }

  renderBody() {
    const { id: paramsId = '' } = this.props.match.params;
    const components = {
      transactions: Transactions,
      account: Account,
      promotions: Promotions,
      integrations: Integrations,
      whiteLabel: WhiteLabel,
    };

    const Component = paramsId in components ? components[paramsId] : Profile;

    const props = {
      ...this.props,
      showAlertModal: this.showAlertModal,
    };

    return <Component {...props} id={paramsId} />;
  }

  render() {
    const publisherTabsAllowed = publisherTabs.reduce((prev, item) => {
      if (item[0].includes('whiteLabel') && !canUserAccessFeature('MOBILE_WHITE_LABEL')) {
        return prev;
      }
      prev.push(item);
      return prev;
    }, []);

    return (
      <React.Fragment>
        <div className="padding-bottom-20px padding-top-20px">
          <span className="title-medium ">Publisher</span>
          <a
            href={`${STATIC_HOMEPAGE_URL}/publishers/${this.props.userInfo.publisherID}`}
            title="View Publisher Page">
            <span className="text-medium" style={{ marginLeft: 15, color: Colors.mainOrange }}>
              <strong>View Publisher Page</strong>
            </span>
          </a>
        </div>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <NavPills className="nav nav-pills">
              {publisherTabsAllowed.map((tab, i) => {
                return this.props.history.location.pathname === tab[0] ? (
                  <li key={`tabKey${i}`} role="presentation" className="active">
                    <Link to={tab[0]} style={{ backgroundColor: 'transparent' }}>
                      <span style={{ fontSize: 15, fontWeight: 600, color: Colors.mainOrange }}>
                        {tab[1]}
                      </span>
                    </Link>
                  </li>
                ) : (
                  <li key={`tabKey${i}`} role="presentation">
                    <Link to={tab[0]}>
                      <span style={{ fontSize: 15, fontWeight: 600 }}>{tab[1]}</span>
                    </Link>
                  </li>
                );
              })}
            </NavPills>
            {this.renderBody()}
          </div>
        </div>
        <MuiThemeProvider>{this.renderAlertModal()}</MuiThemeProvider>
      </React.Fragment>
    );
  }
}

const NavPills = styled.ul`
  li.active {
    background: #fff;
  }
`;

export default Publisher;
